import { takeEvery, fork, put, all, call, select } from "redux-saga/effects";
import {
  apiError,
  getList,
  listSuccessful,
  addRecordSuccessful,
  getRecordByIdSuccessful,
  accountPaymentApprovalSuccessful,
  isViewModelVisible,
} from "./accountPaymentSlice";
import {
  postAdd,
  getParamsList,
  getList as getById,
  postEdit,
  postDelete,
  patchEdit,
} from "../../../helpers/Helper";
import { axiosInstance } from "../../../helpers/AxiosHelper";
import { Modal } from "antd";
import { RiCheckboxCircleLine, RiAlertLine } from "react-icons/ri";

function* FetchList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = payload.sortOrder + payload.currentSort;
      } else if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/payments/account-payments/",
      params,
    );
    yield put(listSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* Add({ payload }) {
  try {
    const { obj, profileObj } = payload;
    if (obj.id == 0) {
      const response = yield call(postAdd, "/payments/account-payments/", obj);
      if (response.status === 201 || response.status === 200) {
        if (
          profileObj?.attachment &&
          typeof profileObj.attachment !== "string"
        ) {
          const formData = new FormData();
          formData.append("attachment", profileObj.attachment);
          yield call(
            [axiosInstance, "put"],
            "/payments/account-payments/attachment/" + response.data.id,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );
        }
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Account Payment Added Successfully!
            </p>
          ),
        });
        yield put(getList({ page: 1, search: "", page_size: 10 }));
        yield put(addRecordSuccessful());
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Unable to add. Please try again!
            </p>
          ),
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/payments/account-payments/" + obj.id,
        obj,
      );
      if (response.status === 200 || response.status === 201) {
        if (
          profileObj?.attachment &&
          typeof profileObj.attachment !== "string"
        ) {
          const formData = new FormData();
          formData.append("attachment", profileObj.attachment);
          yield call(
            [axiosInstance, "put"],
            "/payments/account-payments/attachment/" + obj.id,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );
        }
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Account Payment Updated Successfully!
            </p>
          ),
        });
        yield put(getList({ page: 1, search: "", page_size: 10 }));
        yield put(addRecordSuccessful());
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Unable to update. Please try again!
            </p>
          ),
        });
      }
    }
  } catch (error) {
    var errorMessages = [];
    var data = error?.response?.data;
    if (data && typeof data === "object") {
      Object.keys(data).forEach((key) => {
        const label = key.replace(/_/g, " ");
        if (Array.isArray(data[key])) {
          data[key].forEach((msg) => errorMessages.push(`${label}: ${msg}`));
        } else if (typeof data[key] === "string") {
          errorMessages.push(`${label}: ${data[key]}`);
        }
      });
    }
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          {errorMessages.length > 0
            ? errorMessages.map((msg, i) => (
                <p key={i} className="hp-p1-body hp-text-color-black-80 hp-mb-4">{msg}</p>
              ))
            : <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>
          }
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* Delete({ payload }) {
  try {
    const response = yield call(
      postDelete,
      "/payments/account-payments/" + payload,
    );
    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">
            Account Payment deleted!
          </p>
        ),
      });
      const params = yield select((state) => state.accountPayment.params);
      yield put(getList({ page: params.page, search: params.search, page_size: params.page_size }));
      // yield put(getList({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">Unable to delete!</p>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>
      ),
    });
    yield put(apiError(error));
  }
}

function* FetchById({ payload }) {
  try {
    const response = yield call(
      getById,
      "/payments/account-payments/" + payload,
    );
    yield put(getRecordByIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* FsyncStatus({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/payments/account-payments/repost/" + payload.id,
      {}
    );
    if (response.post_status == true) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Account Payment successfully synchronised into Focus</p>,
      });
    } else {
      Modal.error({
        icon: <span className="remix-icon"><RiAlertLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Account Payment not posted on Focus.Please try again!</p>,
      });
    }
      const params = yield select((state) => state.accountPayment.params);
      yield put(getList({ page: params.page, search: params.search, page_size: params.page_size }));
    // yield put(getList({ page: 1, search: "", page_size: 10 }));
  } catch (error) {
    console.log(error,"error")
    const errorMessage = error?.response?.data?.error || error?.message || "Something went wrong";
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p>,
    });
    yield put(apiError(errorMessage));
  }
}

function* AccountPaymentApproval({ payload }) {
  try {
    const response = yield call(
      patchEdit,
      "/payments/account-payments/approve/" + payload.id,
      { approval_status: payload.approval_status, approval_remarks: payload.approval_remarks },
    );
    if (response.status === 200) {
      if (payload.approval_status === 2) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Account Payment has been approved successfully.</p>,
        });
      } else if (payload.approval_status === 3) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Account Payment has been rejected successfully.</p>,
        });
      }
      yield put(accountPaymentApprovalSuccessful());
      yield put(isViewModelVisible(false));
      const params = yield select((state) => state.accountPayment.params);
      yield put(getList({ page: params.page, search: params.search, page_size: params.page_size }));
    } else {
      Modal.error({
        icon: <span className="remix-icon"><RiAlertLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Unable to process. Please try again!</p>,
      });
      yield put(apiError("Unable to process approval"));
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* AccountPaymentSaga() {
  yield all([
    fork(function* () {
      yield takeEvery("accountPayment/getList", FetchList);
    }),
    fork(function* () {
      yield takeEvery("accountPayment/addRecord", Add);
    }),
    fork(function* () {
      yield takeEvery("accountPayment/deleteRecord", Delete);
    }),
    fork(function* () {
      yield takeEvery("accountPayment/getRecordById", FetchById);
    }),
    fork(function* () {
      yield takeEvery("accountPayment/fsyncStatusUpdate", FsyncStatus);
    }),
    fork(function* () {
      yield takeEvery("accountPayment/accountPaymentApproval", AccountPaymentApproval);
    }),
  ]);
}

export default AccountPaymentSaga;
